"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrizesByLevel = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var usePrizesByLevel = function (levelInfo) {
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var result = [];
        var cash = Number(((_b = (_a = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusMoney) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b[currentCurrency || 'EUR']) || 0);
        if ((_c = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.cashback) === null || _c === void 0 ? void 0 : _c.percent) {
            result.push({
                value: "".concat((_d = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.cashback) === null || _d === void 0 ? void 0 : _d.percent, " %"),
                title: t('dailyCashBack'),
            });
        }
        // For FLASHDASH
        var bonusMaxBet = Number(
        // @ts-ignore
        ((_f = (_e = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusMaxBet) === null || _e === void 0 ? void 0 : _e.amount) === null || _f === void 0 ? void 0 : _f[currentCurrency]) || 0);
        if (bonusMaxBet && bonusMaxBet > 0) {
            result.push({
                value: "".concat(bonusMaxBet, " ").concat(currentCurrency),
                title: t('cashBonus'),
            });
        }
        if (cash && cash > 0)
            result.push({
                value: "".concat(cash, " ").concat(currentCurrency),
                image: '/img/prizes/cash.svg',
                wager: "".concat(t('wager'), ": ").concat((_g = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusMoney) === null || _g === void 0 ? void 0 : _g.wager),
            });
        if ((levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) &&
            typeof (levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) === 'string') {
            result.push({
                value: levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins,
                title: t('freespins'),
            });
        }
        if (((_h = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) === null || _h === void 0 ? void 0 : _h.number) &&
            ((_j = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) === null || _j === void 0 ? void 0 : _j.number) > 0) {
            result.push({
                value: "".concat((_k = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) === null || _k === void 0 ? void 0 : _k.number, " ").concat(t('fs')),
                image: "/img/prizes/freespins".concat((_l = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) === null || _l === void 0 ? void 0 : _l.number, ".png"),
                betAmount: "".concat(t('betAmount'), ": ").concat((((_o = (_m = levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.bonusFreeSpins) === null || _m === void 0 ? void 0 : _m.betAmount) === null || _o === void 0 ? void 0 : _o[currentCurrency]) || 0) / 100, " ").concat(currentCurrency),
            });
        }
        return result;
    }, [currentCurrency, levelInfo, t]);
};
exports.usePrizesByLevel = usePrizesByLevel;
